module.exports = __webpack_public_path__ + "img/native-icon.742ea2c2.svg";